<template>
    <div>
        <div class="brdr_box_w_checkbox">
            <div class="theme">
                <h3>Theme</h3>
                <div class="theme-options">
                    <label :class="{'active-option': appConfig.theme !== 'dark'}"
                           @click="changeTheme('white')">
                        <input type="radio" name="theme" value="white" v-model="appConfig.theme">
                        <div class="theme-option-item">
                            <img :src="require('@/assets/img/fpay-theme-white.png')">
                            <div class="theme-option-badge">White</div>
                        </div>
                    </label>
                    <label :class="{'active-option': appConfig.theme === 'dark'}"
                           @click="changeTheme('white')">
                        <input type="radio" name="theme" value="dark"
                               v-model="appConfig.theme">
                        <div class="theme-option-item">
                            <img :src="require('@/assets/img/fpay-theme-dark.png')">
                            <div class="theme-option-badge">Dark</div>
                        </div>
                    </label>
                </div>
            </div>
        </div>

        <div class="brdr_box_w_checkbox">
            <div class="r_country">
				<h3 style="margin-bottom: 6px">
					Payment options
					<info-icon>
						<div>
							<p> Add as many payment options as you want.</p>
							<p>Select any option to be the default selected payment option (on page load).</p>
						</div>
					</info-icon>
				</h3>
				<Container
					@drop="onDrop"
					lock-axis="y"
					class="payment-options-container"
					:drop-placeholder="placeholderOptions"
					non-drag-area-selector=".no-drag"
					v-if="paymentMethods.length"
				>
					<Draggable v-for="(method, methodIndex) in paymentMethods" :key="method.group_id+'_'+methodIndex">
						<div class="payment-option-entry">
							<div class="payment-option-header">
								<label class="switch_checkbox_item radio_box_item" >
									<input type="radio" name="default_method"
										:checked="appConfig.default_method == method.group_id"
										:value="method['group_id']"
										@change="changeDefaultMethod(method['group_id'])"
									>
									<div class="switch_checkbox"><span></span></div>
								</label>
								<div class="option-title">
									<img v-if="method.method_logo" :src="method.method_logo" />
									<span v-else class="no-drag method-title" contenteditable="true"
									      @blur="method.title=$event.target.innerText">{{method.title}}</span>

									<span class="option-ext">Through <b>{{method['gateway_name']}}</b></span>
								</div>
								<a class="panel_item_btn "
								   @click="edit(methodIndex, method)" v-tippy="{theme:'small-black'}" content="Configure">
									<inline-svg :src="require('@/assets/img/settings.svg')"/>
								</a>
								<a class="panel_item_btn delete_btn" v-tippy="{theme:'red-small'}" content="Remove"
								   @click="deleteMethod(methodIndex, method)">
									<inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
								</a>
							</div>
							<div class="option-content" v-if="appConfig.default_method == method['group_id']">
<!--								STRIPE, NMI, Checkout, MOLLIE -->
								<div class="cc-container layout-column" v-if="method.info && method.group_id===1">
									<div class="flex layout-column" v-if="method.gateway_id===gateways.GATEWAY_MOLLIE">
										<span class="cc-field no-drag" contenteditable="true"
										      @blur="updateMethodInfo(method, 'cardHolder', $event.target.innerText)">
											{{methodInfo(method).cardHolder}}
										</span>
										<span class="cc-input">eg. James Smith</span>
									</div>

									<div class="flex layout-column" >
										<span class="cc-field no-drag" contenteditable="true"
										      @blur="updateMethodInfo(method, 'cc', $event.target.innerText)">
											{{methodInfo(method).cc}}
										</span>
										<span class="cc-input">1234 1234 1234 1234</span>
									</div>
									<div class="flex layout-row">
										<div class="flex layout-column">
											<span class="cc-field no-drag" contenteditable="true"
											      @blur="updateMethodInfo(method, 'expiry', $event.target.innerText)">
												{{methodInfo(method).expiry}}
											</span>
											<span class="cc-input">{{methodInfo(method).expiry}}</span>
										</div>
										<div style="width: 20px"></div>
										<div class="flex layout-column">
											<span class="cc-field no-drag" contenteditable="true"
											      @blur="updateMethodInfo(method, 'cvc', $event.target.innerText)">
												{{methodInfo(method).cvc}}
											</span>
											<span class="cc-input">{{methodInfo(method).cvc}}</span>
										</div>
									</div>
								</div>

								<!-- iDEAL -->
								<div class="cc-container layout-column" v-else-if="method.info && method.group_id===5">
									<span class="no-drag info-message" contenteditable="true"
									   @blur="method.info=$event.target.innerText">{{method.info || ''}}</span>
									<div class="flex layout-column" v-if="method.gateway_id!==gateways.GATEWAY_MOLLIE_IDEAL">
										<span class="cc-input">Select bank</span>
									</div>
								</div>

								<!-- EPS -->
								<div class="cc-container layout-column" v-else-if="method.info && method.group_id===12">
									<editable-span class="info-message" placeholder="Select your bank"
									               v-model="methodInfo(method).select_a_bank"
									               @input="updateMethodInfo(method,'select_a_bank', $event)"/>
									<div class="flex layout-column" >
										<span class="cc-input">Select your bank</span>
									</div>

<!--									<span class="info-message _tos" v-tippy="{theme:'small-black'}" content="This is a required TOS notice">-->
<!--										Oświadczam, że zapoznałem się z-->
<!--										<a href="https://www.przelewy24.pl/regulamin" target="_blank">regulaminem</a> i-->
<!--										<a href="https://www.przelewy24.pl/obowiazekinformacyjny" target="_blank">obowiązkiem informacyjnym</a>-->
<!--										serwisu Przelewy24.-->
<!--									</span>-->

									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>Otherwise, it will be shown in <b>Austria</b> only.
											</span>
										</template>
									</v-switch>

									<!--									<editable-span class="info-message" placeholder="TOS"-->
									<!--									               v-model="methodInfo(method).tos"-->
									<!--									               @input="updateMethodInfo(method,'tos', $event)"/>-->
								</div>

								<!-- P24 -->
								<div class="cc-container layout-column" v-else-if="method.info && method.group_id===10">
									<editable-span class="info-message" placeholder="Select a P24 bank"
									               v-model="methodInfo(method).select_a_bank"
									               @input="updateMethodInfo(method,'select_a_bank', $event)"/>
									<div class="flex layout-column" >
										<span class="cc-input">Select a P24 bank</span>
									</div>

									<span class="info-message _tos" v-tippy="{theme:'small-black'}" content="This is a required TOS notice">
										Oświadczam, że zapoznałem się z
										<a href="https://www.przelewy24.pl/regulamin" target="_blank">regulaminem</a> i
										<a href="https://www.przelewy24.pl/obowiazekinformacyjny" target="_blank">obowiązkiem informacyjnym</a>
										serwisu Przelewy24.
									</span>

									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>Otherwise, it will be shown in supported countries only ie. <b>Poland</b>.
											</span>
										</template>
									</v-switch>

<!--									<editable-span class="info-message" placeholder="TOS"-->
<!--									               v-model="methodInfo(method).tos"-->
<!--									               @input="updateMethodInfo(method,'tos', $event)"/>-->
								</div>

								<!-- RazorPay -->
								<div class="cc-container layout-column" v-else-if="method.info && method.group_id===11">
									<p class="no-drag info-message" contenteditable="true"
									   @blur="method.info=$event.target.innerText">{{method.info}}</p>
									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>By default, Funnelish only shows <b>RazorPay</b> option to customers in <b>India</b>.</span>
										</template>
									</v-switch>
								</div>

								<!-- Buy now, Pay later -->
								<!-- Klarna direct -->
								<klarna v-else-if="method.group_id===6 && method.gateway_id===19" :method="method" />

								<!-- Klarna through Stripe -->
								<div v-else-if="method.group_id===6">
									<p class="no-drag info-message" contenteditable="true"
									   @blur="method.info=$event.target.innerText">{{method.info}}</p>
									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<div>
												<p>Normally Funnelish only shows <b>Buy now, Pay later</b> option for locations that support it.</p>
												<p><u>Currently Klarna is supported in:</u></p>
												<p><i>Austria, Belgium, Denmark, Finland, France, Germany, Italy, Netherlands, Norway, Spain, Sweden, United Kingdom and United States.</i></p>
											</div>
										</template>
									</v-switch>
								</div>

								<!-- Bancontact -->
								<div v-else-if="method.group_id===7">
									<p class="no-drag info-message" contenteditable="true"
									   @blur="method.info=$event.target.innerText">{{method.info}}</p>
									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>Otherwise, it will be shown in <b>Belgium</b> only.</span>
										</template>
									</v-switch>
								</div>

								<!-- SOFORT -->
								<div v-else-if="method.group_id===8">
									<p class="no-drag info-message" contenteditable="true"
									   @blur="method.info=$event.target.innerText">{{method.info}}</p>
									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>Otherwise, it will be shown in supported countries only ie.
												<b>Austria, Belgium, Germany, Italy, Netherlands and Spain</b>.
											</span>
										</template>
									</v-switch>
								</div>

								<!-- SEPA -->
								<div v-else-if="method.group_id===9">

									<div class="cc-container" >
										<div class="flex layout-column" >
										<span class="cc-field no-drag" contenteditable="true"
										      @blur="updateMethodInfo(method, 'IBAN', $event.target.innerText)">
											{{methodInfo(method).IBAN || 'IBAN'}}
										</span>
											<span class="cc-input">GB82WEST12345698765432</span>
										</div>
									</div>

									<v-switch class="margin-rl-20 margin-t-25" :value="method.always_show"
									          v-model="method.always_show"
									          label="Always show this option regardless of customers' location">
										<template v-slot:info>
											<span>Otherwise, it will be shown in <b>Single Euro Payments Area</b> countries only.
											</span>
										</template>
									</v-switch>
								</div>

								<p v-else-if="method.info" class="no-drag info-message" contenteditable="true"
								      @blur="method.info=$event.target.innerText">{{method.info}}</p>
								<p v-else class="info-message" >
									This will be the default selected payment method, you may select a different one if needed.
								</p>
							</div>
						</div>
					</Draggable>
				</Container>

	            <p v-if="!paymentMethods.length">Click the button below to connect and add your payment methods.</p>
              <v-button class="add_fm_btn add_payment_method bottom-entry" :class="{'round':!paymentMethods.length}"
                @click="isPopupOpen=true">Add a new payment method</v-button>

	            <div class="alert_box red margin-t-15" v-if="!appConfig.default_method || paymentMethods.filter(x=>x.group_id == appConfig.default_method).length===0">
		            <inline-svg class="icon" :src="require('@/assets/img/alert_icon_red.svg')" />
		            No default payment method is selected! Click the radio button next to a payment method to make it the default one.
	            </div>
          </div>
      </div>

		<AddPaymentMethodPopup v-if="isPopupOpen" :current-payment-method="currentPaymentMethod"
		                       :funnel="funnel" @close="isPopupOpen=false;currentPaymentMethod=null"
		                       @gatewayClicked="pushNewGateway"/>
    </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue"
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag } from '@/helpers/sort'

import AddPaymentMethodPopup from "@/views/funnels/apps/funnel-apps/fpay/AddPaymentMethodPopup";
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import VSwitch from "@/components/base/v-switch";
import EditableSpan from "@/modules/page-editor/src/components/base/editable-span";
import Klarna from "@/views/funnels/apps/funnel-apps/fpay/gateways/klarna";
import * as gateways from "@/helpers/gateways"

export default {
    name: 'FunnelishPay',
    props: ['dataBufferObject', 'funnel'],
    components: {
	    Klarna,
	    EditableSpan,
	    VSwitch,
	    InfoIcon,
	    VButton,
	    AddPaymentMethodPopup,
		Tooltip,
		Container, Draggable,
    },
    data() {
        return {
	        placeholderOptions: {
		        className: 'option-drag-placeholder',
		        animationDuration: '150',
		        showOnTop: true
	        },
	        isPopupOpen: false,
	        currentPaymentMethod: null,
	        showMethods: false,
	        gateways
        }
    },
    computed: {
	    appConfig() {
	    	return this.dataBufferObject;
	    },
	    paymentMethods: {
	    	get() {
	    		if (!this.appConfig.payment_methods) { // maintain reactivity.
	    			this.$set(this.appConfig, 'payment_methods', []);
			    }
	    		return this.appConfig.payment_methods;
		    }
	    }
    },
    methods: {
			isDynamic(method) {
				// is direct Klarna?
				return method.group_id===6 && method.gateway_id===19
			},
	    updateMethodInfo(method, field, value) {
				let info = {};
				if (typeof method.info === 'object')
					info = method.info;
				else
					info = JSON.parse(method.info)

		    info[field] = value;
		    method.info = JSON.stringify(info);
		    this.$emit('update');
	    },
	    methodInfo(method) {
				try {
					if (!method.info) return {};
					if (typeof method.info === 'object') return method.info;
					return JSON.parse(method.info);
				} catch (e) {
					console.error(e)
					return {}
				}
	    },
    	deleteMethod(index, method) {
		    this.paymentMethods.splice(index, 1)
	    },
	    edit(index,method) {
				this.currentPaymentMethod = method;
				this.isPopupOpen = true;
	    },
	    changeTheme(theme) {
		    this.$set(this.appConfig, "theme", theme); // Preserve reactivity if .theme is not defined.
		    this.$emit('update');
	    },
	    changeDefaultMethod(MethodGroupId) {
    		// XXX: default_method must be a string (backward compatibility with Emberjs).
		    this.$set(this.appConfig, "default_method", MethodGroupId+""); // Preserve reactivity if .default_method is not defined.
		    this.$emit('update');
	    },
//     "payment_methods\":[
//         {\"group_id\":3,\"user_gateway_id\":578,\"gateway_id\":5,\"funnel_id\":1016,\"method_title\":\"Cash On Delivery\",\"method_logo\":\"\",\"gateway_name\":\"COD\"},
//         {\"group_id\":2,\"user_gateway_id\":592,\"gateway_id\":7,\"funnel_id\":1016,\"method_title\":\"PayPal\",\"method_logo\":\"/img/gateways/paypal.png\",\"gateway_name\":\"g2Xx\"},
//         {\"group_id\":1,\"user_gateway_id\":611,\"gateway_id\":1,\"funnel_id\":1016,\"method_title\":\"Credit Card\",\"method_logo\":\"\",\"gateway_name\":\"STRP z1\"}
//     ],
//     \"default_method\":\"1\",
//     \"theme\":\"dark\",
//     \"test_mode\":true
// }"

	    pushNewGateway(userGateway) {
		    try {
					this.currentPaymentMethod = null;
			    let groupId = userGateway.gateway.method_group_id;
			    this.isPopupOpen = false;

			    let targetIndex = this.paymentMethods.findIndex(item => item.group_id === groupId);
			    let ccGateways = ['nmi','stripe','checkout.com','mollie'];
					let title = userGateway.gateway.name;
					if (ccGateways.indexOf(userGateway.gateway.key) >= 0)
						title = "Credit/Debit Card";
					else if (userGateway.gateway.key === "stripe-klarna")
						title = "Buy now, Pay later (Klarna)";
					else if (userGateway.gateway.key === "stripe-bancontact")
						title = "Bancontact";
					else if (userGateway.gateway.key === "stripe-sofort")
						title = "Direct Bank Transfer";
					else if (userGateway.gateway.key === "stripe-sepa")
						title = "SEPA Direct Debit";
					else if (userGateway.gateway.key==="klarna")
						title = "Pay later with Klarna"

			    let method = {
				    "group_id": groupId,
				    "user_gateway_id": userGateway.id,
				    "gateway_id": userGateway.gateway_id,
				    "funnel_id": parseInt(this.$route.params.id),
				    "method_title": userGateway.gateway.name,
				    "method_logo": userGateway.gateway.image_url,
				    "title": title,
				    "gateway_name": userGateway.name,
				    "info": userGateway.gateway.info,
			    }

			    if (targetIndex < 0) {
				    this.paymentMethods.push(method);
			    } else {
				    this.paymentMethods.splice(targetIndex, 1, method);
			    }
			    this.changeDefaultMethod(groupId);
		    } catch (e) {
		    	this.$error(e);
		    } finally {

		    }
		},
		arraymove(arr, fromIndex, toIndex) {
			var arrayBuffer = arr;
			var element = arrayBuffer[fromIndex];
			arrayBuffer.splice(fromIndex, 1);
			arrayBuffer.splice(toIndex, 0, element);

			return arrayBuffer;
		},
		async onDrop (dropResult) {
			this.$set(this.appConfig, 'payment_methods', this.arraymove(this.paymentMethods, dropResult.removedIndex, dropResult.addedIndex));
        },
    },
    created(){
		// console.log('appConfig:', this.appConfig);
    }
}
</script>
<style lang="scss" scoped>
.__dynamic-title {
	font-weight: 500;
	color: $dark-grey;
	font-size: .95rem;
	display: inline-flex;
	flex-direction: row;
	white-space: nowrap;
	align-items: center;
	gap: 5px;
	margin-right: 10px;
}
.info-message {
	line-height: 1.5;
	align-items: center;
	margin: auto !important;

	&._tos {
		user-select: all;
		cursor: text;
		a {
			color: $blue !important;
		}
	}
}
.cc-field {
	width: fit-content;
}
.cc-container {
	margin: 10px;
	padding: 10px;
	border-radius: 5px;
	background: $light-blue;
	.cc-input {
		border: 1px solid grey;
		box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.27);
		height: 34px;
		border-radius: 6px;
		margin-top: 3px;
		margin-bottom: 10px;
		line-height: 34px;
		padding: 0 10px;
		color: #bebebe;
	}
}
.panel_item_btn {
	min-height: 34px;
	min-width: 34px;
	height: 34px;
	width: 34px;
	svg {
		height: 16px;
		width: 16px;
	}
}
</style>
<style lang="scss">

.theme-options {
	display: flex;
	justify-content: space-between;
	margin-top: 10px;

	label {
		width: calc(50% - 10px);
		display: flex;
		flex-direction: column;
		cursor: pointer;
		transition: all 0.3s ease;
		&:hover {
			img {
				border-color: #4368e0;
				box-shadow: 0 0 1px 2px #4368e0;
			}
		}
	}
	img {
		display: block;
		width: 200px;
		max-width: 100%;
		height: 110px;
		object-fit: cover;
		object-position: top;
		border-radius: 10px;
		box-shadow: 0 0 0 1px #e5e6f1;
		margin: 0 auto 15px;
	}
	.active-option {
		.theme-option-badge {
			background: #4368e0;
			color: #fff;
		}
		img {
			box-shadow: 0 0 0 2px #4368e0;
		}
	}
}

.theme {
	width: 100%;
}

.theme-option-badge {
	padding: 10px 15px;
	border-radius: 5px;
	background: #f6f9fe;
	display: inline-block;
}

.theme-option-item {
	text-align: center;
}

.round {
	border-radius: 5px !important;
}

.form-group.with_top_block {
	padding-top: 5px;
}
.form-group.with_top_block .form_group_top_block {
	top: 5px;
}

.popup {
	.payment-option-header {
		cursor: pointer;
	}
}

</style>
<style lang="scss">
.option-drag-placeholder {
	background: $light-blue;
	border-radius: 3px;
	border: 2px dashed $grey !important;
}
</style>
